<template>
  <div>
    <editor
      v-model="editorValue"
      :api-key="apiKey"
      :init="init">
    </editor>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'TinyEditor',

  components: {
    Editor,
  },

  props: {
    value: {
      type: String,
      default: '',
    },

    toolbar: {
      type: String,
      default: 'bold italic underline | link',
    },

    plugins: {
      type: String,
      default: 'link',
    },

    apiKey: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      init: {
        height: 300,
        branding: false,
        menubar: false,
        statusbar: false,
        toolbar: this.toolbar,
        plugins: this.plugins,
        default_link_target: '_blank',
        language: 'nl',
        language_url: '/lang/nl.js',
      },
      editorValue: this.value,
    };
  },

  watch: {
    value() {
      this.editorValue = this.value;
    },

    editorValue() {
      this.$emit('input', this.editorValue);
    },
  },
}
</script>



// WEBPACK FOOTER //
// resources/js/components/TinyEditor.vue